<template>
  <div class="pricegroup-row" v-if="pricegroup && pricegroup.pricegroup">
    <div class="row align-items-center">
      <div class="col">
        <div class="pricegroup-title">
          {{ transName(pricegroup.pricegroup.title) }}
          <span v-if="promoAmount > 1" class="badge badge-danger ml-1">1+{{ promoAmount - 1 }}</span>
        </div>
        <div class="text-muted" v-if="transName(pricegroup.pricegroup.description)">{{ transName(pricegroup.pricegroup.description) }}</div>
        <div class="text-muted d-block d-md-none mt-2">
          {{ trans('left') }}: {{ pricegroup.cnt | formatNumber }}
        </div>
      </div>
      <div class="col-3 col-lg-2 d-md-block d-none">
        <div class="text-muted">
          {{ trans('left') }}: {{ pricegroup.cnt | formatNumber }}
        </div>
      </div>
      <div class="col-auto">
        <div class="pricegroup-price">
          {{ pricegroup.pricegroup.price | formatNumber }} ₸
        </div>
      </div>
      <div class="col-auto">
        <div class="d-flex align-items-center">
          <a class="plus-btn" :class="{ disabled: amount < 1 }" @click="changeAmount('-')">-</a>
          <span class="amount-span">{{ amount }}</span>
          <a class="minus-btn" :class="{ disabled: amount >= max }" @click="changeAmount('+')">+</a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'

export default {
  name: "SelectPricegroupTicketsAmount",
  props: {
    pricegroup: {
      type: Object
    },
    section: {
      type: Object
    },
  },
  computed: {
    ...mapState(['cart', "ticketsLimit", "timetable"]),
    // topstar pricegroup campaign: 1 position = N separate tickets ("1 + (N - 1)")
    promoAmount() {
      if(this.timetable?.vendor !== 'topstar') return 1
      return this.pricegroup?.pricegroup?.amount_of_tickets || 1
    },
    max() {
      return Math.min(Math.floor(this.pricegroup.cnt / this.promoAmount), this.ticketsLimit)
    },
    amount() {
      return this.cart.reduce((a, v) => (v.pricegroup_id === this.pricegroup.pricegroup.id ? a + 1 : a), 0)
    }
  },
  methods: {
    changeAmount(sign) {
      if(sign === '+' && this.amount >= this.max) return
      if(sign === '-' && this.amount <= 0) return
      let ticket = {
        price: this.pricegroup.pricegroup.price,
        pricegroup_id: this.pricegroup.pricegroup.id,
        pricegroup_amount_of_tickets: this.pricegroup?.pricegroup?.amount_of_tickets || 1,
        section_id: this.section?.id || null,
        section_title: this.section?.title || null,
      }
      // console.log(ticket)
      ticket.pricegroup_name = this.pricegroup.pricegroup.title
      this.$store.commit('updateCart', { sign, ticket, ignoreGTag: false })
    }
  }
}
</script>
